import Link from 'antd/es/typography/Link';
import React from 'react';

import { EMAILS, ONBOARDING_NO_PERMISSION_COPY, URLS } from '@sonar-software/sonar-ts-constants';

export const MissingPermissionMessage: React.FC = () =>
	<p>
		{ ONBOARDING_NO_PERMISSION_COPY.AROVY_UNABLE_TO_CONNECT }
		<br />
		<br />
		{ ONBOARDING_NO_PERMISSION_COPY.PARTIAL_INFORMATION }
		<Link
			href={ ONBOARDING_NO_PERMISSION_COPY.PARTIAL_ZENDESK_LINK }
			target='blank'>
			{ ONBOARDING_NO_PERMISSION_COPY.PARTIAL_HERE }
		</Link>
		{ ONBOARDING_NO_PERMISSION_COPY.PARTIAL_PERIOD }
		<br />
		<br />
		{ ONBOARDING_NO_PERMISSION_COPY.PARTIAL_CONTACT_US }
		<a
			href={ URLS.SUPPORT_EMAIL }
			rel='noopener'
			target='_blank'>
			{ EMAILS.SUPPORT }
		</a>
		{ ONBOARDING_NO_PERMISSION_COPY.PARTIAL_PERIOD }
	</p>;
